import axios from './axios';
import config from '../../helpers/config';

export default (designId, containerId) => (
  axios.delete(`${config.designBuilderLoadDesignPath}/${designId}/containers/${containerId}`)
);
